var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLabel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23745 0.190359H0L4.40073 5.59505L0 11H3.23745L7.63861 5.59505L3.23745 0.190359Z",
    fill: "#2148C0",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95272 0.190359H5.71484L10.116 5.59505L5.71484 11H8.95272L13.3539 5.59505L8.95272 0.190359Z",
    fill: "#2148C0",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLabel);
export default __webpack_public_path__ + "static/media/rightLabel.d606a17ce0f3cb356d10f852a8ce09fe.svg";
export { ForwardRef as ReactComponent };